import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "uploadDocument" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, { fluid: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field_filled, {
            class: "d-flex justify-start",
            outlined: "",
            label: "Fichier",
            modelValue: _ctx.fileName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileName) = $event)),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.inputUpload.click())),
            "prepend-icon": "$attach_file",
            style: {"width":"50%","margin-right":"auto","margin-left":"auto"},
            density: "compact"
          }, null, 8, ["modelValue"]),
          _withDirectives(_createElementVNode("input", {
            ref: "inputUpload",
            type: "file",
            accept: ".csv",
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileChanged && _ctx.onFileChanged(...args)))
          }, null, 544), [
            [_vShow, false]
          ]),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "py-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  (_ctx.fileName)
                    ? (_openBlock(), _createBlock(_component_oss_text_field, {
                        key: 0,
                        modelValue: _ctx.vatRate,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vatRate) = $event)),
                          _cache[4] || (_cache[4] = ($event: any) => (_ctx.computeVatRate()))
                        ],
                        dense: "",
                        outlined: "",
                        suffix: '%',
                        label: "Taux de TVA",
                        style: {"width":"50%","margin-right":"auto","margin-left":"auto"}
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  (_ctx.fileName)
                    ? (_openBlock(), _createBlock(_component_v_window, {
                        key: 0,
                        modelValue: _ctx.wizardStep,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.wizardStep) = $event)),
                        touchless: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_window_item, { value: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-2 justify-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_data_table, {
                                    headers: _ctx.headers,
                                    items: _ctx.data,
                                    class: "table",
                                    "fixed-header": "",
                                    "max-height": "60vh"
                                  }, {
                                    item: _withCtx((props) => [
                                      _createElementVNode("tr", {
                                        class: _normalizeClass(props.item.selected ? 'info ' : ''),
                                        style: _normalizeStyle(
                                                _ctx.isInDB(props.item.importId)
                                                    ? 'background: #FFCDD2'
                                                    : ''
                                            )
                                      }, [
                                        _createElementVNode("td", {
                                          class: "text-center",
                                          style: _normalizeStyle(
                                                    _ctx.isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2 !important'
                                                        : ''
                                                )
                                        }, _toDisplayString(props.item.name), 5),
                                        _createElementVNode("td", {
                                          class: "text-center",
                                          style: _normalizeStyle(
                                                    _ctx.isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2 !important'
                                                        : ''
                                                )
                                        }, _toDisplayString(_ctx.formatDate(props.item.date)), 5),
                                        _createElementVNode("td", {
                                          class: "text-center",
                                          style: _normalizeStyle(
                                                    _ctx.isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2 !important'
                                                        : ''
                                                )
                                        }, _toDisplayString(props.item.thirdParty.name), 5),
                                        _createElementVNode("td", {
                                          class: "text-center",
                                          style: _normalizeStyle(
                                                    _ctx.isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2'
                                                        : ''
                                                )
                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.netAmount,
                                                        undefined,
                                                    )), 5),
                                        _createElementVNode("td", {
                                          class: "text-center",
                                          style: _normalizeStyle(
                                                    _ctx.isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2'
                                                        : ''
                                                )
                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.vatAmount,
                                                        undefined,
                                                    )), 5),
                                        _createElementVNode("td", {
                                          class: "text-center",
                                          style: _normalizeStyle(
                                                    _ctx.isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2'
                                                        : ''
                                                )
                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.grossAmount,
                                                        undefined,
                                                    )), 5),
                                        _createElementVNode("td", {
                                          class: "text-center",
                                          style: _normalizeStyle(
                                                    _ctx.isInDB(props.item.importId)
                                                        ? 'background: #FFCDD2'
                                                        : ''
                                                )
                                        }, _toDisplayString(_ctx.isInDB(props.item.importId)
                                                        ? "Déjà enregistrée"
                                                        : ""), 5)
                                      ], 6)
                                    ]),
                                    _: 1
                                  }, 8, ["headers", "items"]),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "d-flex justify-end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        rounded: "",
                                        elevation: "0",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.wizardStep++)),
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                                          _createTextVNode(" Suivant ")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.companies.length)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_v_col, {
                                          cols: "5",
                                          class: "px-2 flex-shrink-0 flex-grow-1",
                                          style: {"max-height":"50vh","overflow-y":"auto"}
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.fileName)
                                              ? (_openBlock(), _createBlock(_component_v_switch, {
                                                  key: 0,
                                                  modelValue: _ctx.allIsConsumer,
                                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.allIsConsumer) = $event)),
                                                  label: "Tous les clients sont des particuliers"
                                                }, null, 8, ["modelValue"]))
                                              : _createCommentVNode("", true),
                                            (_ctx.companies.length)
                                              ? (_openBlock(), _createBlock(_component_v_list, {
                                                  key: 1,
                                                  width: "100%"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company, index) => {
                                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: index,
                                                        class: "my-1",
                                                        onClick: ($event: any) => (_ctx.companiesSelected = index),
                                                        style: _normalizeStyle(
                                                    index === _ctx.companiesSelected
                                                        ? 'background: rgba(109, 192, 189, 0.3) !important'
                                                        : ''
                                                )
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, null, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(company.name), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(company &&
                                                            company.link &&
                                                            company.link.name
                                                                ? company.link.name
                                                                : ""), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_switch, {
                                                                    modelValue: company.consumer,
                                                                    "onUpdate:modelValue": ($event: any) => ((company.consumer) = $event),
                                                                    "hide-details": "",
                                                                    label: "Particulier"
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                cols: "1",
                                                                class: "d-flex justify-end"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  (company.link && company.link.name)
                                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                        key: 0,
                                                                        color: "secondary"
                                                                      }, {
                                                                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                                          _createTextVNode(" $fa-check-circle ")
                                                                        ])),
                                                                        _: 1
                                                                      }))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick", "style"]))
                                                    }), 128))
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          class: "d-flex align-center justify-center px-2 flex-shrink-1 flex-grow-0",
                                          height: "100%"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                _createTextVNode("$fa-arrow-left")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "px-2 flex-shrink-0 flex-grow-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_CompaniesTable, {
                                              showGenericCompany: false,
                                              showConsumerCompanies: true,
                                              showCustomerCompanies: true,
                                              showSupplierCompanies: false,
                                              showExistingCompanies: false,
                                              parentCompanyId: _ctx.company.id,
                                              company: '',
                                              wizardMode: true,
                                              onSelectCompany: _cache[7] || (_cache[7] = ($event: any) => (
                                                _ctx.companies[_ctx.companiesSelected].link = $event
                                            ))
                                            }, null, 8, ["parentCompanyId"])
                                          ]),
                                          _: 1
                                        })
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    class: "d-flex pt-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.wizardStep--)),
                                        rounded: "",
                                        elevation: "0",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                                          _createTextVNode("Précédent")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "6",
                                    class: "d-flex justify-end pt-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.upload())),
                                        rounded: "",
                                        elevation: "0",
                                        loading: _ctx.uploadLoading,
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                                          _createTextVNode("Upload")
                                        ])),
                                        _: 1
                                      }, 8, ["loading"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}